import React from 'react';
import FilterPill from '../FilterPill/FilterPill';
import './InlineConditionPills.css';

interface InlineConditionPillsProps {
  value: string[]; // Array of selected conditions
  onChange: (value: string[]) => void;
  disabled?: boolean;
}

// Only NM, LP (Slightly Played), MP (Moderately Played) - NO HP/DMG per requirements
const CONDITIONS = ['NM', 'LP', 'MP'] as const;
const CONDITION_MAP: Record<string, string> = {
  'NM': 'NM',
  'LP': 'LP',
  'MP': 'MP'
};

const InlineConditionPills: React.FC<InlineConditionPillsProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const handleToggle = (condition: string) => {
    if (disabled) return;
    
    const newValue = value.includes(condition)
      ? value.filter(v => v !== condition)
      : [...value, condition];
    
    // Ensure at least one condition is selected
    if (newValue.length === 0) {
      return;
    }
    
    onChange(newValue);
  };

  return (
    <div className={`inline-condition-pills ${disabled ? 'disabled' : ''}`}>
      {CONDITIONS.map(condition => (
        <FilterPill
          key={condition}
          label={CONDITION_MAP[condition]}
          active={value.includes(condition)}
          onToggle={() => handleToggle(condition)}
        />
      ))}
    </div>
  );
};

export default InlineConditionPills;